module.exports = __webpack_public_path__ + "img/Watters-Creek.52265298.png";